import { RefObject, useLayoutEffect } from "react";
import { CodeScannerFormat } from "../code-scanner/code-scanner";

export const useBrowserApiCodeDetector = (videoElement: RefObject<HTMLVideoElement>,
                                          formats: CodeScannerFormat[], onValueScanned: (value: string) => void) => {
    const barcodeDetectorInstance = new BarcodeDetector();

    return useLayoutEffect(() => {
        let detectedBarcodes: string[] = [];
        const timer = setInterval((async () => {
            if (!videoElement.current || !videoElement.current.readyState) {
                return;
            }

            const barcodes = (await barcodeDetectorInstance.detect(videoElement.current));
            for (const barcode of barcodes) {
                if (barcode.format === "qr_code" && !formats.includes(CodeScannerFormat.QR_CODE)
                    || barcode.format !== "qr_code" && !formats.includes(CodeScannerFormat.BARCODE)) {
                    continue;
                }

                detectedBarcodes.push(barcode.rawValue);
                detectedBarcodes = detectedBarcodes.slice(-3);

                if (barcode.format !== "code_39" ||
                    (barcode.format === "code_39"
                        && detectedBarcodes.length === 3 && detectedBarcodes.every(b => b === barcode.rawValue))
                ) {
                    onValueScanned(barcode.rawValue);
                }
            }
        }), 350);

        return () => {
            clearInterval(timer);
        };
    }, [videoElement, formats, onValueScanned]);
};
